import React from 'react';
import { mapToNewAccessService } from '../../domain/AccessServiceTypes.js';
import CONTENTO_PRESENTATION_TYPES from '../../domain/ContentoPresentationTypes.js';
import env from '../../env';
import ContentList from '../../ui-components/ContentList/ContentList';
import DisplayWindow from '../../ui-components/DisplayWindow/DisplayWindow.jsx';
import { trackPage } from '../../utils/adform';
import { browserMeasurements } from '../../utils/browserMeasurements.js';
import { generateListTracking } from '../../utils/contentoUtils.js';
import { createStartPageStatistics } from '../../utils/contentStatistics.js';
import { createListTrackingOnClick } from '../../utils/statistics/clientStatistics.js';
import { ReactHelmetPlay } from '../ApplicationHandler/ReactHelmet';
import SendStatistics from '../CommonElements/SendStatistics.js';
import ContinueWatchingList from './ContinueWatchingList';
import { Heading } from './StartPage.styles';
import TipsForYou from './TipsForYou';
import FavoritesList from './FavoritesList';

const RT_NAME_BY_SELECTION_NAME = Object.freeze({
    Populärt: 'pop',
    Senaste: 'late',
    'Sista chansen': 'chance',
    Direktsändningar: 'live',
});

export const rtNameForSelectionName = (selectionName) => RT_NAME_BY_SELECTION_NAME[selectionName] || null;

const URL_BY_SELECTION_NAME = Object.freeze({
    Populärt: '/populara',
    Senaste: '/senaste',
    'Sista chansen': '/sista-chansen',
    Direktsändningar: '/direkt',
});

export const urlForSelectionName = (selectionName) => URL_BY_SELECTION_NAME[selectionName] || null;

class StartPage extends React.Component {
    componentDidMount() {
        trackPage();
    }

    shouldComponentUpdate() {
        return false;
    }

    render() {
        const { analyticsIdentifiers, selections, currentAccessibilityChoice } = this.props;

        let statObject;
        if (typeof window !== 'undefined') {
            const browserSize = browserMeasurements(window);

            statObject = createStartPageStatistics(
                analyticsIdentifiers.viewId,
                analyticsIdentifiers.viewType,
                browserSize
            );
        }

        const currentAccessibilityChoiceContento = mapToNewAccessService(currentAccessibilityChoice);

        return (
            <div data-rt="start-page">
                <ReactHelmetPlay pathForFeeds="/">
                    <meta name="apple-itunes-app" content={`app-id=${env.APPLE_APP_ID}`} />
                </ReactHelmetPlay>
                <Heading>SVT Play</Heading>
                {selections.map((selection) => {
                    const components = [];
                    // Inject tips before Latest
                    if (selection.id === 'latest_start') {
                        components.push(<TipsForYou key="startpage-tips-for-you" />);
                    }

                    const listTracking = generateListTracking(selection);

                    const onItemClick = createListTrackingOnClick(listTracking);

                    switch (selection.presentation) {
                        case CONTENTO_PRESENTATION_TYPES.SHOWCASE:
                            components.push(
                                <DisplayWindow
                                    id={selection.id}
                                    key={`startpage-showcase-${selection.id}`}
                                    heroItem={selection.items[0]}
                                    items={selection.items.slice(1, 7)}
                                    currentAccessibilityChoiceContento={currentAccessibilityChoiceContento}
                                    onItemClick={onItemClick}
                                />
                            );
                            break;
                        case CONTENTO_PRESENTATION_TYPES.PORTRAIT:
                            components.push(
                                <ContentList
                                    id={selection.id}
                                    key={`startpage-portrait-${selection.id}`}
                                    items={selection.items}
                                    presentation={selection.presentation}
                                    headerText={selection.name}
                                    url={urlForSelectionName(selection.name)}
                                    onItemClick={onItemClick}
                                    regTestSpec={rtNameForSelectionName(selection.name)}
                                    expandable
                                />
                            );
                            break;
                        default:
                            components.push(
                                <ContentList
                                    id={selection.id}
                                    items={selection.items}
                                    key={`startpage-default-${selection.id}`}
                                    headerText={selection.name}
                                    url={urlForSelectionName(selection.name)}
                                    onItemClick={onItemClick}
                                    regTestSpec={rtNameForSelectionName(selection.name)}
                                    expandable
                                />
                            );
                    }

                    // Inject continue watching after recommended (Display window)
                    if (selection.id === 'recommended_start') {
                        const listTracking = {
                            listType: 'personlig historik',
                            listID: 'fortsatt titta',
                        };

                        const onItemClick = createListTrackingOnClick(listTracking);

                        components.push(
                            <ContinueWatchingList
                                key="startpage-continue-watching"
                                onItemClick={onItemClick}
                            />
                        );
                    }

                    if (selection.id === 'popular_start') {
                        const listTracking = {
                            listType: 'personlig',
                            listID: 'min-lista',
                        };

                        const onItemClick = createListTrackingOnClick(listTracking);

                        components.push(
                            <FavoritesList key="startpage-favorites" onItemClick={onItemClick} />
                        );
                    }

                    return components;
                })}

                <SendStatistics key="stats" statisticsObject={statObject} />
            </div>
        );
    }
}

export default StartPage;
